import { render, staticRenderFns } from "./started.vue?vue&type=template&id=40f2aa7a&"
import script from "./started.vue?vue&type=script&lang=js&"
export * from "./started.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f2aa7a')) {
      api.createRecord('40f2aa7a', component.options)
    } else {
      api.reload('40f2aa7a', component.options)
    }
    module.hot.accept("./started.vue?vue&type=template&id=40f2aa7a&", function () {
      api.rerender('40f2aa7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/workflow/userList/started.vue"
export default component.exports